'use client';

import { changeLanguage } from '@eliadmin/core/src/server/api-client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export function LanguageSelect({ white = true }: { white?: boolean }) {
  const [isLoading, setIsLoading] = useState(false);
  const locale = useLocaleStore(s => s.currentLocale);
  const locales = useLocaleStore(s => s.supportedLocales);
  const [selectedLocale, setSelectedLocale] = useState(
    locales.find(localeIterator => localeIterator.locale === locale),
  );
  const pathname = usePathname();

  const handleLocaleChange = async (newLocale: string) => {
    let newRoute = `/${newLocale}${pathname}`;
    if (pathname.startsWith(`/${locale}`)) {
      newRoute = pathname.replace(`/${locale}`, `/${newLocale}`);
    }
    setIsLoading(true);
    await changeLanguage({ locale: newLocale });
    window.location.replace(newRoute);
  };

  useEffect(() => {
    setSelectedLocale(locales.find(localeIterator => localeIterator.locale === locale));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const getTextColor = (lang: string) => {
    const isActive = selectedLocale?.locale === lang;
    return white
      ? isActive
        ? 'text-white'
        : 'text-white/50'
      : isActive
      ? 'text-primary'
      : 'text-black/30';
  };

  return (
    <div
      className={cn(
        'ea-language-select flex items-center justify-center gap-1.5 text-base font-bold',
        white ? 'text-white/50' : 'text-black/30',
      )}
    >
      <button
        type="button"
        aria-label="SK – Slovenčina"
        aria-pressed={selectedLocale?.locale === 'sk'}
        onClick={() => handleLocaleChange('sk')}
        className={cn('cursor-pointer', getTextColor('sk'))}
      >
        SK
      </button>
      <p className={cn(white ? 'text-white/50' : 'text-black/30')}>/</p>
      <button
        type="button"
        aria-label="EN – English"
        aria-pressed={selectedLocale?.locale === 'en'}
        onClick={() => handleLocaleChange('en')}
        className={cn('cursor-pointer', getTextColor('en'))}
      >
        EN
      </button>
    </div>
  );
}
